import VueXHelper from '@/modules/core/app/helpers/VueXHelper';
import { Module } from '@/modules/core/app/constants/app.constants';
import { DateRangeState } from './daterange.state';
import { getters } from './daterange.getters';
import { mutations } from './daterange.mutations';
import { actions } from './daterange.actions';

VueXHelper.setStoreModule(Module.DATERANGE, { actions, mutations, getters });

export const store = {
  namespaced: true,
  state: new DateRangeState(),
  getters,
  mutations,
  actions,
};
